import { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../../components/Table";
import { SentinelOneDevicescolumns } from "../../../../components/headerContent";
import RowDevices from "./RowDevices";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Devices() {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getDevices = async () => {
        const res = await axios(`${apiUrl}sentinelone/devices`, {
            method: "get",
            withCredentials: true
        })
        return res.data;
    }

    const devices = useQuery({
        queryKey: ["devices"],
        queryFn: getDevices,
    });

    return (
        <>
            {!devices.isLoading ? (
                <div className='cato-content-table'>
                    <Table
                        tableData={devices.data}
                        tableColumns={SentinelOneDevicescolumns}
                        rowComponent={RowDevices}
                    />
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
}